<div class="topdiv" >



    <div class="row topRowMargins headerStyle" style="margin-top: 0;">
      <div  style="margin-left: 15px;">
        <label class="textColour">Records List</label>
      </div>
    </div>
    <div class="container">
        <div class="row" *ngIf="recordList.length > 0" style="margin-top:
                  -15px;">
          <div class="table-responsive" >
            <table class="table" style="margin-bottom: 0;">
              <caption></caption>
              <thead class="table-heading">
                <!-- style="position: sticky;z-index: 2;top: 0; max-height: 150px;overflow-y: auto;" -->
                <tr>
                  <th class="th-lg text-left"  *ngFor="let field of fields">{{field.label}}</th>
                  <th class="th-lg text-left" style="text-align: end; padding-right: 33px;">Remove</th>
                </tr>
              </thead>
              <tbody style="border:none;" >
                <tr *ngFor="let record of recordList; let k= index;" cdkDrag>
                  <td class="conditionsalign text-left" *ngFor="let field of fields">{{record[field.label]}}</td>
                  <td class="conditionsalign text-left" style="text-align: end; padding-right: 33px;">
                    <label class="CloseButtonStyle">
                      <span><em (click)="deleteWhere(k)" class="fas fa-minus" style="color: white;"
                          title="Remove Filter"></em></span>
                    </label>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

      </div>
    <div>
        <form [formGroup]="dynamicForm">
            <div class="row">
             <!-- <div *ngFor="let label of fields"> -->
                <div *ngFor="let field of fields" class="col-lg-4" style="text-align: end">
                    <mat-form-field appearance="outline">
                    <mat-label i18n="@@TMSTAFFMASTERfirstname">{{field.label}}</mat-label>
         <mat-select *ngIf="field.datatype?.toLowerCase() === 'boolean'" [formControlName]="field.label">
  <mat-option value="Yes">Yes</mat-option>
  <mat-option value="No">No</mat-option>
</mat-select>

<!-- Others: show input -->
<input *ngIf="field.datatype?.toLowerCase() !== 'boolean'" matInput
  [type]="getInputType(field.datatype)"
  [placeholder]="field.label"
  [formControlName]="field.label"
  maxlength="100" />
                    <mat-error *ngIf="dynamicForm.get(field.label)?.hasError('required') && dynamicForm.get(field.label)?.touched">
  {{field.label}} is required
</mat-error>
<mat-error *ngIf="dynamicForm.get(field.label)?.hasError('pattern') && dynamicForm.get(field.label)?.touched">
    Invalid {{field.datatype}} value
  </mat-error>
                    </mat-form-field>
            </div> 
            <div  *ngIf="buttonName == 'Add'" class="col-lg-1" style="text-align: end">
            <div style="width: 15%;text-align: left;">
                <label (click)="addWhere()" style="margin-top: 6px;
                  background: green;
                  margin-bottom: auto;
                  padding: 2px 5px 0px 5px;
                  border-radius: 15px;"><em class="fas fa-plus" style="color:
                    antiquewhite;font-size: large;" title="Add Record"></em></label>
              </div>
              </div>
          <!-- </div> -->
          </div>
        </form>
    </div>
    <div class="col-lg">
        <div class="container" style="text-align: center; margin-left: 25px;">
          <div class="row topRowMargins">
            <div class="col-lg-3"></div>
            <div class="col-lg-5">
            </div>
            <div class="col-lg-2">
              <button i18n="@@TMRunButton" type="button" (click)="saveHeaders()" [style.background-color]="buttonColor"
                class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.5rem;font-size: .85rem;width:100%;">{{buttonName}}</button>
            </div>
            <div class="col-lg-2">
              <button i18n="@@TMRunButton" type="button" (click)="cancel()" [style.border-color]="buttonColor"
                class="cancelButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
                style="padding: .3rem 1.6rem;font-size: .85rem;width:100%;">Cancel</button>
            </div>
    
          </div>
        </div>
      </div>
    </div>